/* src/app/dialog-delete/dialog-delete.component.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 30px;
  padding: 30px;
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
}
::ng-deep dialog-delete.ng-star-inserted > div {
  margin-right: 0px;
  margin-left: 0px;
}
::ng-deep .mat-mdc-dialog-actions {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
::ng-deep .mat-mdc-dialog-title {
  margin-top: 15px !important;
}
/*# sourceMappingURL=dialog-delete.component.css.map */
